// src/components/marketing/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="text-center py-10 text-xs text-gray-500">
      <div className="flex justify-center gap-4 mb-2">
        <Link to="/privacy" className="hover:text-purple-600 transition-colors">
          Privacyverklaring
        </Link>
        <span>|</span>
        <Link to="/algemene-voorwaarden" className="hover:text-purple-600 transition-colors">
          Algemene Voorwaarden
        </Link>
      </div>
      <p>© 2026 LerenMotiveren. Alle rechten voorbehouden.</p>
    </footer>
  );
};

export default Footer;